/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListExternalCredentialsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

/**
 * Only return credentials for this provider.
 */
export const QueryParamProvider = {
  AwsIam: "aws_iam",
  GcpIam: "gcp_iam",
} as const;
/**
 * Only return credentials for this provider.
 */
export type QueryParamProvider = ClosedEnum<typeof QueryParamProvider>;

export type ListExternalCredentialsRequest = {
  /**
   * Only return credentials for this provider.
   */
  provider?: QueryParamProvider | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListExternalCredentialsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListExternalCredentialsSecurity$outboundSchema: z.ZodMiniType<
  ListExternalCredentialsSecurity$Outbound,
  ListExternalCredentialsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listExternalCredentialsSecurityToJSON(
  listExternalCredentialsSecurity: ListExternalCredentialsSecurity,
): string {
  return JSON.stringify(
    ListExternalCredentialsSecurity$outboundSchema.parse(
      listExternalCredentialsSecurity,
    ),
  );
}

/** @internal */
export const QueryParamProvider$outboundSchema: z.ZodMiniEnum<
  typeof QueryParamProvider
> = z.enum(QueryParamProvider);

/** @internal */
export type ListExternalCredentialsRequest$Outbound = {
  provider?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListExternalCredentialsRequest$outboundSchema: z.ZodMiniType<
  ListExternalCredentialsRequest$Outbound,
  ListExternalCredentialsRequest
> = z.pipe(
  z.object({
    provider: z.optional(QueryParamProvider$outboundSchema),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function listExternalCredentialsRequestToJSON(
  listExternalCredentialsRequest: ListExternalCredentialsRequest,
): string {
  return JSON.stringify(
    ListExternalCredentialsRequest$outboundSchema.parse(
      listExternalCredentialsRequest,
    ),
  );
}
